import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiMethod } from '../../apimethods/api-method';
import { Router, ActivatedRoute } from '@angular/router';
import * as ngswal from "sweetalert";
import { NTArtWithdrawn } from './nt-withdue';
import { DataParam, customfunctions } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
declare var $;


@Component({
  selector: 'app-nt-withdue',
  templateUrl: './nt-withdue.component.html',
  styleUrls: ['./nt-withdue.component.css']
})
/** VendorAllocationPM.cs component*/
export class NTArtWithdrawnComponent implements OnInit {
  modelItem = new NTArtWithdrawn();
  @ViewChild('dataAllocatedTable', { static: false }) tableAL;
  dataSetAL: string;
  dataTableAL: any;
  showModal: boolean;
  title: string;
  Popupbutton: string;
  DueDate: any;


  ngOnInit(): void {
    ApiMethod.getBaseUrl();
  }

  /** Vendor pm WithdrawnArticle ctor */
  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <NTArtWithdrawn>data["NTArtWithdrawn"];

        $('#ddlwithtype').select2({
          placeholder: "SelectStatus",
          dropdownParent: "#myModal"
        });
        $('#ddlwithtype').val([]).trigger('change');

        this.GetNTArticleList();

      },
      error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  //LoadAllocatedArticleList:
  GetNTArticleList() {
    $("#LoadingImage").show();
    ApiMethod.getMethod(this.modelItem.GetNTAllocatedArticleList + "/" + localStorage.aLoginID + "/" + localStorage.aPubID).subscribe(
      result => {

        this.dataSetAL = JSON.stringify(result.aAllocateArticleList); // Data List
        this.dataSetAL = JSON.parse(this.dataSetAL);
        this.dataTableAL = $(this.tableAL.nativeElement);
        //Dynamic datable
        let aColLists = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColLists;
        dataItem.aNewButtonName = 'btn_AddAL';
        dataItem.dataTable = this.dataTableAL;
        dataItem.dataset = this.dataSetAL;
        dataItem.dtheight = (GlobalConstants.size.height - 120);
        dataItem.modulename = 'NTAllocatedArtModule';
        dataItem.infoPopupID = 'ID';
        dataItem.StateSave = false;
        this.dataTableAL = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
        
    }   
   );
  }

  ShowAllocateddetails() {
    this.showModal = true;
    if (localStorage.aEID != 0) {
      $("#LoadingImage").show();
      ApiMethod.getMethod(this.modelItem.GetAllocatedArtById + localStorage.aEID).subscribe(
        result => {
          let aitem = result.aArtDetailsById;
         
          console.log(aitem);
          $('#txt_Remarks').val(aitem[0].WithdrawnRemarks);

        },
        error => {
          ngswal("Failed !", error.message, "warning");
        }
      );
      $("#LoadingImage").hide();
      this.title = "Withdrawn Remark";
      this.Popupbutton = "Update";
    } else {
      this.title = "Add VendorWithdrawnStatus";
      this.Popupbutton = "Save";   
    }
  }

  
  DueDateChangeConfirm() {
    ngswal({
      title: "Confirmation",
      text: "Are you confirm Change duedate!",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {
          $('#duedatechange').trigger("click");
        } else {
          return false;
        }
      });
  }
  
  DuedateChange() {
     $("#LoadingImage").show();
    const selectedRow = document.querySelector('#tblVendorAllocatedart tr:nth-child(' + localStorage.rowIdVal + ') td:first-child').textContent;
    var dataParam = {
      PublisherID: localStorage.aPubID,
      ID: selectedRow,
      DueDate: localStorage.datepickerId,
      UpdatedBy: localStorage.aLoginID
    }
    ApiMethod.postMethod(this.modelItem.GetDuedatechange, dataParam).subscribe(
      result => {
        if (result.status) {
          ngswal("Success !", result.message, "success");
        } else {
          ngswal("Failed !", result.message, "warning");
        }
        this.GetNTArticleList();
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }
  WithDrawnChangeConfirm() {
    ngswal({
      title: "Confirmation",
      text: "Are you confirm to Withdrawn the Article!",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {
          $('#withdrawnstatus').trigger("click");
        } else {
          return false;
        }
      });
  }

  WithdrawnStatus() {
    if ($('#txt_Remarks').val() == "") {
      ngswal("Failed !", 'Enter Remarks !', "warning");
    }
    else {
      $("#LoadingImagePopup").show();
      var dataParam = {
        PublisherID: localStorage.aPubID,
        ID: localStorage.aEID,
        WithdrawnRemarks: $('#txt_Remarks').val(),
        UpdatedBy: localStorage.aLoginID
      }
      ApiMethod.postMethod(this.modelItem.UpdateWithdrawnchange, dataParam).subscribe(
        result => {
          if (result.status) {
            this.showModal = false;
            ngswal("Success !", result.message, "success");
          } else {
            ngswal("Failed !", result.message, "warning");
          }
          this.GetNTArticleList();
          $("#LoadingImagePopup").hide();
        }, error => {
          $("#LoadingImagePopup").hide();
          ngswal("Failed !", error.message, "warning");
        }
      );
    }
 
  }

  hide() {
    this.showModal = false;
  }



}

